'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('MainCtrl',
    /**
     * @param $scope
     * @param $rootScope
     * @param $controller
     * @param moment
     * @param $interval
     * @param analyticsService {AnalyticsService}
     * @param dashboardService
     * @return {MainCtrl}
     */
    function($scope, $rootScope, $controller, moment, $interval,
    analyticsService, dashboardService) {

    var mainVm = this;
    $controller('BaseController', {vm : mainVm});

    mainVm.updateTime = updateTime;
    mainVm.getAnalytics = getAnalytics;
    mainVm.time = '';
    mainVm.fileUrl = '';
    mainVm.analytics = {
      totalCount: 0,
      activeCount: 0
    };

    mainVm.baseActivate(activate);

    return mainVm;

    function activate() {
      $interval(updateTime, 500);
      return mainVm.requestStart()
        .then(getAnalytics)
        .then(getWeatherData)
        .catch(mainVm.requestFailure.bind(mainVm))
        .finally(mainVm.requestComplete.bind(mainVm));
    }

    function updateTime() {
      mainVm.time = moment().format('MMMM Do YYYY, HH:mm:ss a');
    }

    function getAnalytics() {
      return analyticsService.getCustomerAnalytics()
        .then(getAnalyticsSuccess)
        .catch(mainVm.requestFailure.bind(mainVm));
    }

    function getAnalyticsSuccess(response) {
      mainVm.analytics.totalCount = response.totalCount;
      mainVm.analytics.activeCount = response.activeCount;
    }

    function getWeatherData() {
      return dashboardService.getWeatherByCity('bolton', 'gb')
        .then(getWeatherDataSuccess)
        .catch(mainVm.requestFailure.bind(mainVm));
    }

    function getWeatherDataSuccess(response) {
      mainVm.weatherData = response;
    }
  });
